export default "__VITE_ASSET__Bq$NzMpJ__"